export default "__VITE_ASSET__BODEjfDf__"